import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import { Accordion } from "react-bootstrap";
import { getSubscriptionPortalLink } from "../../utils/subscription";
import {
  deleteAccount,
  disableTotp,
  registerTotp,
  verifyTotp,
} from "../../utils/account";
import axios from "axios";
import { apiRoot, auth } from "../../index";
import ValidPasswordInput from "../layout/ValidPasswordInput";
import QRCode from "react-qr-code";
import ImportTSPData from "../../utils/profile/ImportTSPData";
import ImportBookingsData from "../../utils/profile/ImportBookingsData";
import WorkingTimeConfig from "./WorkingTimeConfig";
import BillingConfig from "../../utils/profile/BillingConfig";

export default function ProfileContent() {
  const { userInfos } = useContext(UserContext);

  // region new password form

  const [newPassword, setNewPassword] = useState("");

  async function handleNewPasswordSubmit(e) {
    e.preventDefault();
    if (newPassword) {
      setIsFetching(true);

      try {
        await auth.currentUser.updatePassword(newPassword);

        window.alert("Mot de passe mis à jour");
      } catch (e) {
        console.error(e);
        window.alert("Une erreur est survenue");
      }

      setIsFetching(false);
    }
  }

  // endregion

  // region TOTP

  const [totpRegister, setTotpRegister] = useState(null);
  const [totpCode, setTotpCode] = useState("");

  async function onClickRegisterTOTP(e) {
    e.preventDefault();

    const totpRegisterInfos = await registerTotp(userInfos.jwt);
    setTotpRegister(totpRegisterInfos);
  }

  async function onSubmitVerifyTOTP(e) {
    e.preventDefault();

    if (!totpCode) {
      window.alert("Veuillez saisir le code d'authentification");
      return;
    }

    const result = await verifyTotp(userInfos.jwt, totpCode);

    if (result) {
      window.alert("Code d'authentification valide");
      document.location.reload();
    } else {
      window.alert("Code d'authentification invalide");
    }
  }

  async function onClickDisableTOTP(e) {
    e.preventDefault();

    await disableTotp(userInfos.jwt);

    document.location.reload();
  }

  // endregion

  // region handle company form

  const [formError, setFormError] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [company, setCompany] = useState({
    id: "",
    name: "",
    email: "",
    country: "",
    city: "",
    zip: "",
    siren: "",
    revtc: "",
    vat_number: "",
    adresse: "",
    tel: "",
    owner: "",
  });


  useEffect(() => {
    if (userInfos?.company?.id) {
      setCompany(userInfos.company);
    }
  }, [userInfos.company]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompany((old) => ({
      ...old,
      [name]: value,
    }));
  };


  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      setIsFetching(true);

      try {
        await axios.post(
          apiRoot + "/api/v1/update-account",
          {
            ...company,
            id: company.id,
          },
          {
            headers: {
              authorization: userInfos.jwt,
            },
          }
        );

        window.alert("Coordonnées mises à jour avec succès");
      } catch (e) {
        console.error(e);
        if (e?.response?.data === "Invalid value for eu_vat.") {
          window.alert("Numéro de TVA invalide");
        } else {
          window.alert("Une erreur est survenue");
        }
      }

      setIsFetching(false);
    }
  }


  const handleValidation = () => {
    let valid = true;
    let message = [];

    if (!company?.name?.trim()) {
      valid = false;
      message.push("Veuillez saisir le nom de votre société");
    }
    if (!company?.owner?.trim()) {
      valid = false;
      message.push("Veuillez saisir le nom du gérant");
    }
    if (!company?.siren?.trim()) {
      valid = false;
      message.push("Veuillez saisir le SIREN");
    }
    if (!company?.vat_number?.trim()) {
      valid = false;
      message.push("Veuillez saisir le numéro de TVA");
    }
    if (!company?.email?.trim()) {
      valid = false;
      message.push("Veuillez saisir une adresse mail");
    }
    if (!company?.tel?.trim()) {
      valid = false;
      message.push("Veuillez saisir le téléphone");
    }
    if (!company?.country?.trim()) {
      valid = false;
      message.push("Veuillez saisir le pays");
    }
    if (!company?.city?.trim()) {
      valid = false;
      message.push("Veuillez saisir la ville");
    }
    if (!company?.zip?.trim()) {
      valid = false;
      message.push("Veuillez saisir le code postal");
    }
    if (!company?.adresse?.trim()) {
      valid = false;
      message.push("Veuillez saisir l'adresse");
    }

    setFormError(message);

    return valid;
  };

  const renderFormAlert = () => {
    return formError.length > 0 ? (
      <div
        className="alert alert-danger mt-3"
        role="alert"
        style={{ flexDirection: "column", borderRadius: "0" }}
      >
        {formError.map((error, index) => {
          return (
            <div
              className="alert-text"
              key={index}
              style={{ alignSelf: "flex-start" }}
            >
              {error}
            </div>
          );
        })}
      </div>
    ) : null;
  };

  const buttonText = (disabled = false) =>
    isFetching === true ? (
      <button type="submit" className="btn btn-primary" disabled>
        Mise à jour...
      </button>
    ) : (
      <button type="submit" className="btn btn-primary" disabled={disabled}>
        Mettre à jour
      </button>
    );

  // endregion

  async function handleRedirectBillingPortal(e) {
    e.preventDefault();
    window.location.href = await getSubscriptionPortalLink(userInfos.jwt);
  }

  async function handleDeleteAccount(e) {
    e.preventDefault();

    if (!window.confirm("Voulez-vous vraiment supprimer votre compte ?"))
      return;

    try {
      await deleteAccount(userInfos.jwt);
    } catch (e) {}

    window.location.href = "/profile";
  }

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">Gestion du profil</h3>
          </div>
        </div>
      </div>

      <Accordion defaultActiveKey={["0"]} alwaysOpen>
        <Accordion.Item
          eventKey={"0"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Identifiants</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <form onSubmit={handleNewPasswordSubmit} className="kt-form">
              <div className="kt-portlet__body">
                <div className="kt-section kt-section--first">
                  <div className="kt-section__body">
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Adresse mail :
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          value={
                            userInfos?.child?.email ?? userInfos?.email ?? ""
                          }
                          className="form-control"
                          disabled={true}
                          name="email"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Nouveau mot de passe :
                      </label>
                      <div className="col-lg-6">
                        <ValidPasswordInput
                          password={newPassword}
                          setPassword={setNewPassword}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="kt-portlet__foot">
                <div className="kt-form__actions">
                  {buttonText(!newPassword)}
                </div>
              </div>
            </form>
            {renderFormAlert()}
            {!userInfos?.isTotpEnabled && !totpRegister && (
              <>
                <hr />
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={onClickRegisterTOTP}
                  >
                    Activer la double authentification
                  </button>
                </div>
              </>
            )}
            {!userInfos?.isTotpEnabled && totpRegister && (
              <>
                <hr />
                <div>
                  <p className="mb-2">
                    Scannez ce QR Code avec votre application de double
                    authentification pour activer la double authentification.
                    (Google Authenticator, Microsoft Authenticator, Apple Mots
                    de passe, Authy, etc.)
                  </p>
                  <QRCode
                    value={totpRegister.url}
                    size={256}
                    style={{ height: "256px;", width: "256px" }}
                    viewBox={`0 0 256 256`}
                  />
                  <p className="mt-2">
                    Ou entrez ce code dans votre application :{" "}
                    <b>{totpRegister.secretKey}</b>
                  </p>
                  <p className="mt-4">
                    Entrez le code affiché dans votre application ci-dessous :
                  </p>
                  <form onSubmit={onSubmitVerifyTOTP} className="mt-1">
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="totp-input"
                      >
                        Code d'authentification
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          id="totp-input"
                          name="totp"
                          placeholder="XXXXXX"
                          value={totpCode}
                          onChange={(e) => setTotpCode(e.target.value)}
                        />
                      </div>
                    </div>
                    <button className="btn btn-primary">Valider</button>
                  </form>
                </div>
              </>
            )}
            {userInfos?.isTotpEnabled && (
              <>
                <hr />
                <div>
                  <button
                    className="btn btn-primary"
                    onClick={onClickDisableTOTP}
                  >
                    Désactiver la double authentification
                  </button>
                </div>
              </>
            )}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item
          eventKey={"1"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Coordonnées</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <form onSubmit={handleFormSubmit} className="kt-form">
              <div className="kt-portlet__body">
                <div className="kt-section kt-section--first">
                  <div className="kt-section__body">
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Raison Sociale:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          value={company.name}
                          className="form-control"
                          name="name"
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">Gérant:</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="owner"
                          value={company.owner}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">SIREN:</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="siren"
                          value={company.siren}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">REVTC:</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="revtc"
                          value={company.revtc || ""}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                          inputMode="numeric"
                          placeholder="Numéro REVTC"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Numéro de TVA:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="vat_number"
                          value={company.vat_number}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">Email:</label>
                      <div className="col-lg-6">
                        <input
                          value={company.email}
                          type="email"
                          className="form-control"
                          name="email"
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Téléphone:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="tel"
                          className="form-control"
                          name="tel"
                          value={company.tel}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">Pays:</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="country"
                          value={company.country}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">Ville:</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          value={company.city}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Code Postal:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="zip"
                          value={company.zip}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-3 col-form-label">
                        Adresse:
                      </label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="adresse"
                          value={company.adresse}
                          onChange={handleChange}
                          disabled={userInfos.createdBy}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="kt-portlet__foot">
                {!userInfos.createdBy && (
                  <div className="kt-form__actions">{buttonText()}</div>
                )}
              </div>
            </form>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item
          eventKey={"2"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Facturation</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <BillingConfig />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item
          eventKey={"3"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Configuration des heures de travail</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <WorkingTimeConfig />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item
          eventKey={"4"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Import de données</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <ImportTSPData />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item
          eventKey={"5"}
          className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
        >
          <Accordion.Header className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title fs-6">Import de réservations</h3>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <ImportBookingsData />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="mt-3">
        {userInfos &&
        !userInfos.createdBy &&
        userInfos.subscription &&
        userInfos.subscription.status === "active" ? (
          <>
            <button
              className="btn btn-secondary"
              onClick={handleRedirectBillingPortal}
            >
              Gérer mon abonnement
            </button>
            <br />
          </>
        ) : null}
        <button
          onClick={handleDeleteAccount}
          className="btn btn-outline-danger mt-3"
        >
          Supprimer mon compte
        </button>
      </div>
    </div>
  );
}
